import React from 'react';
import { Box } from '@mui/material';

const MediaUploadButton = ({
  onClickCallBack,
  uploadComplete,
}) => {
  const handleClick = () => {
    onClickCallBack();
  };
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'fit-content',
      }}
      onClick={handleClick}
    >
      {uploadComplete ? (
        <img src="/assets/upload-complete.svg" alt="media upload complete icon" />
      ) : (
        <img src="/assets/media-upload-btn.svg" alt="media upload icon" />
      )}
    </Box>
  );
};

export default MediaUploadButton;
